import { GzAddRuleWebComponent } from './component/GzAddRuleWebComponent';
import { GzRuleCriteriaWebComponent } from './component/ruleDefinition';
export { GzAddRuleWebComponent, GzRuleCriteriaWebComponent };

export const WizardMaxStepWithAutomaticActions = 4;
export const WizardMaxStepWithoutAutomaticActions = 3;
export const WizardMinStep = 1;
